import { CONFIG_DORCHESTER } from './dorchester';
import { CONFIG_TRAILBORN } from './trailborn';

export const getHotelConfig = (hotelId) => {
  switch (String(hotelId)) {
    case '42380':
    case '60010':
    case '60011':
    case '60012':
    case '60013':
    case '60022':
    case '60023':
    case '60024':
    case '60025':
    case '60336':
      return CONFIG_DORCHESTER;

    case '38601':
    case '38606':
    case '46091':
    case '47356':
    case '68622':
      return CONFIG_TRAILBORN;

    default:
      return null;
  }
};
